import { type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export function SectionLabel({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('text-[15px] font-semibold text-text-secondary pl-0.5', className)}>
      {children}
    </div>
  );
}
